import type {AdPreviewDataForGrid} from '@frontend/modules/public/ads/AdsModuleTypes'
import type {ExecutorPreviewData} from '@frontend/modules/public/services/ServicesModuleTypes'
import type {ApiResponseData} from '@frontend/types/AppTypes'
import {ApiRequestService} from 'swayok-react-mdb-ui-kit/services/ApiRequestService'

// API избранных объявлений.
export const FavouritesApi = {

    // Получить избранные объявления.
    async getAdsList(
        this: void,
        limit: number,
        offset: number = 0
    ): Promise<AdPreviewDataForGrid[]> {
        return ApiRequestService
            .get<AdsListResponseData>('/v1/items/favorites', {
                limit,
                offset,
            })
            .then(response => response.data.records)
    },

    // Получить избранных исполнителей услуг.
    async getExecutorsList(
        this: void,
        limit: number,
        offset: number = 0
    ): Promise<ExecutorPreviewData[]> {
        return ApiRequestService
            .get<ExecutorsListResponseData>('/v1/executors/favorites', {
                limit,
                offset,
            })
            .then(response => response.data.records)
    },

    // Добавление/удаление объявления из избранного.
    async changeStateForAd(
        this: void,
        id: number,
        isFavourite: boolean
    ): Promise<void> {
        return ApiRequestService
            .post<ApiResponseData>(`/v1/item/${id}/` + (isFavourite ? 'like' : 'unlike'))
            .then(() => {
            })
    },

    // Добавление/удаление исполнителя услуг из избранного.
    async changeStateForExecutor(
        this: void,
        id: number,
        isFavourite: boolean
    ): Promise<void> {
        return ApiRequestService
            .post<ApiResponseData>(`/v1/executor/${id}/` + (isFavourite ? 'like' : 'unlike'))
            .then(() => {
            })
    },
}

export interface AdsListResponseData extends ApiResponseData {
    records: AdPreviewDataForGrid[]
    count: number
}

export interface ExecutorsListResponseData extends ApiResponseData {
    records: ExecutorPreviewData[]
    count: number
}
